// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"d13c85a7","155":"83bb9f32","387":"d4cbdff8","453":"033fbed9","534":"7423dcf2","591":"58f59474","648":"b4a83179","749":"4ca59857","779":"d7f97be5","924":"a4af61d2"}[chunkId] + ".chunk.js";
};